import '../about.css';
import { useEffect, useRef, useState } from 'react';
function AboutUs(){
    const carouselRef = useRef(null);
    const [index, setIndex] = useState(0);
  
    const images = [
      "images/truck_fleet_1.webp",
      "images/truck_fleet_2.webp",
      "images/truck_load.webp"
    ];
  
    useEffect(() => {
      const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % images.length);
      }, 3000);
      return () => clearInterval(interval);
    }, [images.length]);
  
    useEffect(() => {
      if (carouselRef.current) {
        const width = carouselRef.current.offsetWidth;
        carouselRef.current.scrollTo({
          left: index * width,
          behavior: 'smooth',
        });
      }
    }, [index]);  
  
return (
     <section id="about" className="about-section">
       {/* <div className="container">
        <h2>About Us</h2>
        <p> We are a South India-based goods transportation company specializing in both domestic export and import services. With years of experience in the logistics sector, we provide safe, timely, and cost-effective cargo movement across Tamil Nadu And Karnataka.</p>
        <p> Whether you're moving bulk goods, commercial products, or custom shipments, we handle it with professionalism and care. </p>
        <div className="fleet-gallery">
            <img src="images/truck_fleet_1.jpg" alt="Fleet Truck 1"></img>
            <img src="images/truck_fleet_2.jpg" alt="Fleet Truck 2"></img>
            <img src="images/truck_load.jpg" alt="Loading Operations"></img>
        </div>
        </div>*/}

        <div className='about-section'>
            <div className='content-section'>
                <div className='left-section'>
                    <div className='about-text-content'>
                    <h2>About Us</h2>
                    <p> Since 2014, we have been a South India-based goods transportation company specializing in both domestic export and import services. With years of experience in the logistics sector, we provide safe, timely, and cost-effective cargo movement across Karnataka, Tamil Nadu, and Kerala.</p>
                    <p> Whether you're moving bulk goods, commercial products, or custom shipments, we handle it with professionalism and care. </p>
                    <div className="experience-badge"> <i className="fas fa-award"></i> 11+ Years of Trusted Service</div>
                    </div>
                </div>
                <div className='right-section'>
                <div className="carousel-wrapper">
                    <div className="fleet-carousel" ref={carouselRef}>
                        <div className="carousel-track">
                        {images.map((src, i) => (
                            <img key={i} src={src} alt={`Fleet ${i}`} />
                        ))}
                        </div>
                    </div>
                    <div className="dot-indicators">
                        {images.map((_, i) => (
                        <span
                            key={i}
                            className={`dot ${index === i ? 'active' : ''}`}
                            onClick={() => setIndex(i)}
                        ></span>
                        ))}
                    </div>
                </div>
                </div>
            </div>
        </div>
    </section>

    

);
}
export default AboutUs